import { horarios as horariosClass } from '@/utils/horarios.class.js'
export default {
    getRestaurantesListado(state) {
        var res = [];
        state.restaurantesArray.forEach((r) => {
            let aux = r;
            aux.horariosApertura = aux.horariosComputados;;
            res.push(aux);
        })
        return res;
    },
    getClientesList(state, getters, rootState) {
        const clientes = state.clientesRestaurante;
        const restGest = rootState.app.restauranteGest;
        return clientes.filter((r) => {
            return r.restaurantes.some(r => restGest.indexOf(r) >= 0)
        })

    },
    getRestaurantesSelect(state) {
        let devolver = [];
        for (let rest of state.restaurantesArray) {
            let aux = {
                value: rest.id,
                text: rest.nombre
            }
            devolver.push(aux);
        }
        return devolver;
    },
    getSelectImpresoras(state, getters, rootState) {
        let res = [];
        if (Array.isArray(rootState.negocios.impresorasNegocio)) {
            rootState.negocios.impresorasNegocio.forEach(imp => {
                if (state.ordenadoresRest.includes(imp.computer.id)) {
                    let aux = {
                        id: imp.id,
                        mostrarSelect: imp.id + '-' + imp.name + '-' + imp.computer.name,
                        nombre: imp.name,
                        desc: imp.description,
                        computerName: imp.computer.name,
                        computerId: imp.computer.id
                    }
                    res.push(aux);
                }
            });
        }
        return res;
    },
    //toma todos los mapeos dee restaurantes  y neo
    getAllProductosMapeadosRest(state) {
        return state.restaurantesArray.map(r => {
            return {
                id: r.id,
                mapeoNeo: r.productosMapeados ? r.productosMapeados : []
            }
        });
    },

    getRestaurantesBossNegocio(state) { //toma los restaurantes y las configuraiones de TPV y lo mezcla
        return state.restaurantesArray.map(r => {
            let f = state.confTpvRest.find(rConf => rConf.id === r.id);
            return {
                ...r,
                confTpv: !!f ? f.confTpv : false
            }
        })
    }
}